import axios from "axios";
import { Config } from "../../../core/config/config";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment-b2b/order`;

export const supplierOrderListService = {

    getOrderList: async function (
        RetailerAccountCode: string
        , productCode: string
        , productCategoryCode: string
        , orderStartDate: Date
        , orderEndDate: Date
        , deliveryStartDate: Date
        , deliveryEndDate: Date
        ,Type:string) {
        return axios.get(`${GATEWAY_URL}/list`, {
            params: {
                RetailerAccountCode: RetailerAccountCode,
                productCode: productCode,
                productCategoryCode: productCategoryCode,
                orderStartDate: orderStartDate,
                orderEndDate: orderEndDate,
                deliveryStartDate: deliveryStartDate,
                deliveryEndDate: deliveryEndDate,
                Type:Type
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getOrderDetailList: async function (orderId: number) {
        return axios.get(`${GATEWAY_URL}/lines`, {
            params: {
                orderId: orderId
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getOrderDetail: async function (orderId: number) {
        return axios.get(`${GATEWAY_URL}/get`, {
            params: {
                orderId: orderId
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getProductsLookups: async function (loadOptions: any) {
        return axios.get(`${GATEWAY_URL}/products`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getCategoriesLookups: async function (loadOptions: any) {
        return axios.get(`${GATEWAY_URL}/categories`, {
        })
            .then((response) => {
                return response.data;
            });
    },


    order_approve: async function (orderId?: number) {
        return axios.get(`${GATEWAY_URL}/order_approve`, {
            params: {
                OrderId: orderId
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    order_reject: async function (orderId: number, rejectReason: string) {
        return axios.get(`${GATEWAY_URL}/order_reject`, {
            params: {
                OrderId: orderId,
                RejectReason: rejectReason
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    updatePreorderBatch: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/qty_approvement`, values)
            .then((response) => {
                return response.data;
            });
    },


    getAccountsLookups: async function (loadOptions: any) {
        return axios.get(`${GATEWAY_URL}/accounts`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getLocationsLookups: async function (loadOptions: any) {
        return axios.get(`${GATEWAY_URL}/order_reason`, {
        })
            .then((response) => {
                return response.data;
            });
    },

}

